import { ANONYMOUS, UNIDENTIFIED } from './analyticsSharedConstants.ts';

const FALLBACK_KEY_PREFIX = '__fallback__:';

export const toUsableIdentityAccountId = (value?: string | null): string | undefined => {
	if (!value) {
		return undefined;
	}
	if (value === ANONYMOUS || value === UNIDENTIFIED) {
		return undefined;
	}
	if (value.startsWith('ari:') || value.startsWith(FALLBACK_KEY_PREFIX)) {
		return undefined;
	}
	return value;
};

export const pickUsableAgentAccountId = (
	records: readonly {
		accountId?: string | null;
		userProfile?: { id?: string | null } | null;
	}[],
): string | undefined => {
	for (const record of records) {
		const id = toUsableIdentityAccountId(record.userProfile?.id ?? record.accountId);
		if (id) {
			return id;
		}
	}
	return undefined;
};

/** A grouped row can represent one profile only when every activity identifies the same account. */
export const pickAgentJobTitleForAccountId = (
	records: readonly {
		accountId?: string | null;
		userProfile?: { id?: string | null; jobTitle?: string | null } | null;
	}[],
	accountId?: string,
): string | null | undefined => {
	if (
		!accountId ||
		!records.every(
			(record) =>
				toUsableIdentityAccountId(record.userProfile?.id ?? record.accountId) === accountId,
		)
	) {
		return undefined;
	}
	return records.find(
		(record) => record.userProfile?.id === accountId && record.userProfile.jobTitle,
	)?.userProfile?.jobTitle;
};
